// extracted by mini-css-extract-plugin
export default {"content":"popover_content__GSm6I"};